import { render, staticRenderFns } from "./CoursesEnrolled.vue?vue&type=template&id=1972a24d"
import script from "./CoursesEnrolled.vue?vue&type=script&lang=js"
export * from "./CoursesEnrolled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports